import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=318f0e30&"
import script from "./NotificationList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NotificationList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=318f0e30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports